<template>
  <div id="app">
    

      <section v-if="tela === 'escolha'" id="escolha">
          <EscolherModoDeJogo :EscolherModo="EscolherModo"/>
      </section>

      <section v-if="tela === 'escolherDica'">

         <BotaoEscolherDica :actionChoiceValues="setValues"/>    
              <button class="give_up" v-on:click="reset">Voltar</button>
      </section>

      <section v-if="tela === 'inicio'" id="inicio">
        
        <Formulario defina="Defina a palavra" :action="setPalavra" v-if="etapa == 'palavra' " title="Palavra para seu amigo ao lado:" button="Próximo"/>
         <button class="give_up" v-on:click="reset">Voltar</button>

      </section>


      <section v-if="tela === 'inicio'" id="jogo">
      
      <Formulario defina="Defina a dica" :action="setDica" v-if="etapa == 'dica' " title="Uma palavra pra ajudar seu amigo" button="Iniciar jogo"/>
       <button class="give_up" v-on:click="reset">Voltar</button>
      </section>  

      <section v-if="tela === 'jogo'">
       
       <Jogo :jogarNovamente="jogarNovamente" :erros="erros" :palavra="palavra" :dica="dica" :verificarLetra="verificarLetra" :etapa="etapa" :letras="letras" :winsorfail="winsorfail" :jogar="jogar"/>
     
      </section>


  </div>
</template>

<script>

import 'animate.css';
import './css/Global.css';
import Formulario from './components/Formulario';
import Jogo from './components/Jogo'
import BotaoEscolherDica from './components/BotaoEscolherDica'
import EscolherModoDeJogo from './components/MododeJogo'

var palavras_sorteadas_tecnologia = [
  {palavradavez:'RUBY',dica:'Linguagem'},
  {palavradavez:'Pascal',dica:'Linguagem'},
  {palavradavez:'Python',dica:'Linguagem'},
  {palavradavez:'Firebase',dica:'Banco de dados'},
  {palavradavez:'Javascript',dica:'Linguagem'},
  {palavradavez:'MariaDB',dica:'Banco de dados'},
  {palavradavez:'MongoDB',dica:'Banco de dados'},
  {palavradavez:'Oracle',dica:'Banco de dados'},
  {palavradavez:'nuvem',dica:'armazenamento'},
  {palavradavez:'SCRUM',dica:'Métodologia'},
  {palavradavez:'DEVOPS',dica:'Métodologia'},
  {palavradavez:'LARAVEL',dica:'Framework'},
  {palavradavez:'DJANGO',dica:'Framework'},
  {palavradavez:'Materialize',dica:'Framework'},
  {palavradavez:'Bootstrap',dica:'Framework'},
  {palavradavez:'redes',dica:'telecomunicação'},
  {palavradavez:'spring',dica:'java'},
  {palavradavez:'cloud',dica:'nuvem'},
  {palavradavez:'Hotmail',dica:'Mensagens'},
  {palavradavez:'hardware',dica:'Físico'},
  {palavradavez:'flutter',dica:'framework'},
  {palavradavez:'Dart',dica:'linguagem'},
  {palavradavez:'nubank',dica:'Banco'},
  
]
var palavras_sorteadas_profissao = [
  
  {palavradavez:'Fisioterapia',dica:'Saúde'},
  {palavradavez:'Jornalismo',dica:'Comunicação'},
  {palavradavez:'Juiz',dica:'Cargo público'},
  {palavradavez:'Marketing',dica:'Mídias'},
  {palavradavez:'Designer',dica:'Criativo'},
  {palavradavez:'Professor',dica:'Fundamental'},
  {palavradavez:'Padeiro',dica:'Comerciante'},
  {palavradavez:'Autor',dica:'livro'},
  {palavradavez:'Vendedor',dica:'Comunicativo'},
  {palavradavez:'Suporte',dica:'Comunicativo'},
  {palavradavez:'Produtor',dica:'Criativo'},
  {palavradavez:'Fazendeiro',dica:'Campo'},
  {palavradavez:'agricultor',dica:'rural'},
  {palavradavez:'Futebol',dica:'Esporte'},
  {palavradavez:'boxe',dica:'Esporte'},
  {palavradavez:'Corrida',dica:'Esporte'},
  {palavradavez:'Volei',dica:'Esporte'},
  {palavradavez:'Arquiteto',dica:'Modelagem'},

]
var palavras_sorteadas_animais = [
  {palavradavez:'Golfinho',dica:'Aquático'},
  {palavradavez:'Camelo',dica:'Mamífero'},
  {palavradavez:'ovelha',dica:'Mamífero'},
  {palavradavez:'Caranguejo',dica:'Aquático'},
 {palavradavez:'Foca',dica:'Aquático'},
  {palavradavez:'Coelho',dica:'herbívoro'},
  {palavradavez:'Girafa',dica:'herbívoro'},
  {palavradavez:'Zebra',dica:'herbívoro'},
   {palavradavez:'Cavalo',dica:'herbívoro'},
   {palavradavez:'Tigre',dica:'Carnívoros'},
   {palavradavez:'Hiena',dica:'Carnívoros'},
   {palavradavez:'Esquilo',dica:'Onívoro'},
   {palavradavez:'Tartaruga',dica:'Silvestre'},
   {palavradavez:'Gafanhoto',dica:'herbívoro'},
   {palavradavez:'Canguru',dica:'Mamífero'},
   {palavradavez:'Javali',dica:'Mamífero'},
]
var palavras_sorteadas_objetos = [
  {palavradavez:'Geladeira',dica:'Doméstico'},
  {palavradavez:'Cama',dica:'Doméstico'},
  {palavradavez:'Panela',dica:'Doméstico'},
  {palavradavez:'Talher',dica:'Doméstico'},
   {palavradavez:'Controle',dica:'Video game'},
  {palavradavez:'Carregador',dica:'Eletrônico'},
  {palavradavez:'Lapis',dica:'Escolar'},
  {palavradavez:'Fone',dica:'Eletrônico'},
  {palavradavez:'Copo',dica:'Cozinha'},
  {palavradavez:'Capa',dica:'Livro'},
  {palavradavez:'Mouse',dica:'Computador'},
  {palavradavez:'Gaveta',dica:'Tem na cozinha'},
  {palavradavez:'porta',dica:'casa'},
  {palavradavez:'Gaita',dica:'Instrumento'},
  {palavradavez:'Viola',dica:'Instrumento'},
  {palavradavez:'Monitor',dica:'Eletrônico'},
  {palavradavez:'Sabonete',dica:'Higiene'},
  {palavradavez:'Mochila',dica:'escola'},
   {palavradavez:'notebook',dica:'Eletrônico'},
]


export default {
  name: 'App',
  data(){
    return{
      tela: 'escolha',
      etapa: 'escolha',
      palavra: '',
      dica: '',
      erros: 0,
      letras:[],
     palavras_sorteadas_tecnologia: palavras_sorteadas_tecnologia,
     palavras_sorteadas_animais: palavras_sorteadas_animais,
     palavras_sorteadas_objetos: palavras_sorteadas_objetos,
     palavras_sorteadas_profissao: palavras_sorteadas_profissao,
     selected: null,
     winsorfail: false,
     positive:false,
    }
  },
  components:{
    Formulario,
    Jogo,
    BotaoEscolherDica,
    EscolherModoDeJogo
  },

  methods:{
    setPalavra: function(palavra){
      this.palavra = palavra;
      this.etapa = 'dica';
    },
     setDica: function(dica){
      this.dica = dica;
      this.tela = 'jogo';
      this.etapa = 'jogo';
     },
     EscolherModo: function(modo,etapa){
       this.tela = modo
       this.etapa = etapa
     },
     setValues: function(values){
       
      switch(values){
         case 'tecnologia':
         this.sortearTecnologia()
         break;
        case 'animais': 
         this.sortearAnimais()
         break;
       case 'objetos':
         this.sortearObjetos()
         break;
       case 'profissao':
         this.sortearProfissao()
         break;
      } 
     },

     reset:function(){
       this.palavra = '';
       this.erros = '';
       this.erros = 0;
       this.letras = [];
       this.tela = 'escolha';
       this.etapa = 'escolha';
     },

     verificarLetra:function(letra){
       return this.letras.find(item => item.toLowerCase() === letra.toLowerCase());
     },
     jogar: function(letra){
       this.letras.push(letra);
       this.verificarErros(letra)
     },
     verificarErros: function(letra){
       //Acerto
       var errou = new Audio('./songs/wrong.mp3');
       var acertou = new Audio('./songs/contain.mp3');
       if(this.palavra.toLowerCase().indexOf(letra.toLowerCase()) >= 0){
         acertou.play();
         return this.verificarAcertos();
       }
       
       errou.play(); 
       this.erros++;
        //Enforcado
        if(this.erros == 6){
          this.etapa = 'enforcado';
          this.winsorfail = true;
        }
     },
     verificarAcertos: function(){
       let letrasUnicas = [...new Set(this.palavra.split(''))];
       if(letrasUnicas.length === (this.letras.length - this.erros)){
         this.winsorfail = false;
         this.etapa = 'ganhador';
         this.positive = true;
       }
     },
     jogarNovamente: function(){
       this.palavra = '';
       this.erros = '';
       this.erros = 0;
       this.letras = [];
       this.tela = 'escolha';
       this.etapa = 'escolha';
     },
     randomPalavra(Palavras){
       return Palavras[Math.floor(Math.random() * Palavras.length)];
     },

     sortearTecnologia(){
       this.selected = this.randomPalavra(this.palavras_sorteadas_tecnologia);
       this.tela = 'jogo'
       this.etapa = 'jogo'
       this.palavra = this.selected.palavradavez
       this.dica = this.selected.dica
     },
        sortearAnimais(){
       this.selected = this.randomPalavra(this.palavras_sorteadas_animais);
       this.tela = 'jogo'
       this.etapa = 'jogo'
       this.palavra = this.selected.palavradavez
       this.dica = this.selected.dica
     },
     sortearObjetos(){
       this.selected = this.randomPalavra(this.palavras_sorteadas_objetos);
       this.tela = 'jogo'
       this.etapa = 'jogo'
       this.palavra = this.selected.palavradavez
       this.dica = this.selected.dica
     },
       sortearProfissao(){
       this.selected = this.randomPalavra(this.palavras_sorteadas_profissao);
       this.tela = 'jogo'
       this.etapa = 'jogo'
       this.palavra = this.selected.palavradavez
       this.dica = this.selected.dica
     },
   
  }
 
}
</script>

<style scoped>

  #app{
    display:flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    flex-direction: column;
    background: linear-gradient(to bottom, rgb(42, 1, 58) 0%, rgb(0, 0, 0) 100%);
    overflow-x: hidden;
  }
  .give_up{
    font-weight: bold;
    cursor: pointer;
    padding: 10px 0;
    width: 120px;
    position: fixed;
    bottom: 10px;
    right: 10px;
    border:1px solid rgba(255,255,255,0.1);
    background:transparent;
    transition: ease-in-out 0.5s;
  }

  .give_up:hover,.give_up:active{
    background:rgba(183, 195, 6, 0.589);
  }
  
</style>
